/**
 * SSO pro Virtus Leadflow (plataforma separada de gestão de leads).
 *
 * O virtus-leadflow não tem login próprio — o backend dele faz proxy de
 * /auth/login, /auth/me e /auth/context-options direto pro SMM, e o frontend
 * guarda o token do SMM como se fosse a própria sessão. Então o SSO aqui é só
 * repassar o access_token atual do SMM via querystring.
 */
const LEADFLOW_BASE_URL = (
  (import.meta.env.VITE_LEADFLOW_URL as string | undefined) ||
  "https://leadflow.virtusautomation.com"
).replace(/\/$/, "");

/** URL de entrada com SSO (ou a home, sem sessão no SMM). Usada também pela rota /launch. */
export function getLeadflowSsoUrl(): string {
  const token = localStorage.getItem("access_token");
  if (!token) return LEADFLOW_BASE_URL;
  return `${LEADFLOW_BASE_URL}/?sso_token=${encodeURIComponent(token)}`;
}

export function openLeadflowSSO(): void {
  window.open(getLeadflowSsoUrl(), "_blank", "noopener,noreferrer");
}
